import React from "react";
import { Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import TimeAgoTag from "~/components/app/TimeAgoTag";

const { Text } = Typography;

export interface LastModifiedTagProps {
  time: Date;
  prefix?: string;
}

function LastModifiedTag({ time, prefix }: LastModifiedTagProps) {
  return (
    <Text type="secondary">
      <small>
        <EditOutlined />
        <span className="mx-2">{prefix}最后修改于</span>
        <TimeAgoTag time={time} />
      </small>
    </Text>
  );
}

export default LastModifiedTag;
